import { useCallback, useState } from "react";

export function useMultistep(totalSteps: number) {
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const firstStep = currentIndex === 0;
  const lastStep = currentIndex === totalSteps - 1;

  const nextStep = () => {
    setCurrentIndex((prev) => (prev >= totalSteps - 1 ? prev : prev + 1));
  };

  const backStep = () => {
    setCurrentIndex((prev) => (prev <= 0 ? prev : prev - 1));
  };

  const goToStep = useCallback((step: number) => {
    setCurrentIndex(step - 1);
  }, []);

  return {
    currentIndex,
    currentStepNumber: currentIndex + 1,
    firstStep,
    lastStep,
    nextStep,
    backStep,
    goToStep,
  };
}
